module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 21.c665edb4.png";